import React from 'react';
import { Footer, Text } from 'grommet';

const FooterApp = () => {
    const currentYear = new Date().getFullYear();
    return (
        <>
            <Footer background="brand" pad="small" justify="center">
                <Text textAlign="center">© Copyright - Pedro Paulo Mendonça Telho - {currentYear.toString()}</Text>
            </Footer>
        </>
    );
}

export default FooterApp;